import "prebid.js/modules/sparteoBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";
import {SparteoAdUnit} from "header-bidding-base/modules/config/domain/bidders/sparteoConfig";

export class SparteoBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<SparteoAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.SPARTEO);
    }
}
